import {Component, OnInit} from '@angular/core';
import {SignUpProgressEnum} from '../../interfaces/SignUpProgressEnum';
import {Select, Store} from '@ngxs/store';
import {ProfileState} from '../../../shared/states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';
import {IUser} from '../../../shared/interfaces/user.interface';
import {Router} from '@angular/router';
import {AuthState} from '../../../shared/states/auth/auth.state';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Logout} from '../../../shared/states/auth/auth.actions';
import {combineLatest} from 'rxjs';
import {take, withLatestFrom} from 'rxjs/operators';
import {SavePharmacyDetails, SavePharmacyForm, SavePharmacyNPI, SavePharmacySelectedBaa, SetCurrentPharmacy} from '../../../shared/states/pharmacy/pharmacy.actions';
import {TransactionsState} from '../../../shared/states/transactions/transactions.state';
import {PharmacyLocationEnum} from '../../../shared/components/pharmacy-details/PharmacyLocationEnum';
import {PharmacyDetailsStepsEnum} from '../../interfaces/PharmacyDetailsStepsEnum';
import {GetDashboardSummary} from '../../../shared/states/transactions/transactions.actions';
import {UserHasPin} from '../../../shared/states/auth/auth.actions';
import {UserRolesEnum} from '../../../shared/interfaces/UserRolesEnum';
import {PharmacyState} from '../../../shared/states/pharmacy/pharmacy.state';
import { IPharmacy } from 'src/app/shared/interfaces/pharmacy.interface';

@UntilDestroy()
@Component({
  selector: 'app-set-up',
  templateUrl: './set-up.component.html',
  styleUrls: ['./set-up.component.scss'],
})
export class SetUpComponent implements OnInit {
  pharmacyDetailsStep: PharmacyDetailsStepsEnum = PharmacyDetailsStepsEnum.NpiNumber;
  signUpProgress = SignUpProgressEnum.PharmacyDetails;
  signUpProgressSteps = [
    'Create account',
    'Pharmacy details',
    'Set your PIN',
  ];
  showSignUpProgressDialog: boolean;

  UserRolesEnum = UserRolesEnum;
  adminRoles = [UserRolesEnum.GlobalAdmin, UserRolesEnum.CompanyAdmin, UserRolesEnum.PharmacyAdmin];

  SignUpProgressEnum = SignUpProgressEnum;
  PharmacyLocationEnum = PharmacyLocationEnum;

  @Select(ProfileState.loading) loading$: Observable<boolean | undefined>;
  @Select(PharmacyState.loading) loadingPharmacy$: Observable<boolean | undefined>;
  @Select(PharmacyState.success) success$: Observable<boolean | undefined>;
  @Select(TransactionsState.dashboardSummary) dashboardSummary$: Observable<any>;
  @Select(AuthState.currentUser) user$: Observable<IUser>;
  @Select(AuthState.pharmacyId) pharmacyId$: Observable<string>;
  @Select(PharmacyState.currentPharmacy) currentPharmacy$: Observable<IPharmacy>;
  @Select(AuthState.userHasPinResponse) userHasPin$: Observable<boolean>;

  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(new GetDashboardSummary())
      .pipe(take(1)).subscribe();

    this.store.dispatch(new UserHasPin())
      .pipe(take(1))
      .subscribe(() => {
        combineLatest([
          this.userHasPin$,
          this.pharmacyId$,
          this.currentPharmacy$
        ]).subscribe(([userHasPin, id, pharmacy]) => {
          this.showSignUpProgressDialog = !userHasPin || ((!id || id === 'undefined') && pharmacy?.role === UserRolesEnum.CompanyAdmin);
          this.signUpProgress = !id || id === 'undefined' ? SignUpProgressEnum.PharmacyDetails : SignUpProgressEnum.SetPIN;
        });
      });
  }

  goToPage(route: string): void {
    this.router.navigateByUrl(route);
  }

  signUpStepSelected(step: number): void {
  }

  signUpCancel(): void {
    this.store.dispatch(new Logout());
    this.goToPage('auth/sign-up');
  }

  savePharmacyForm(formValue: any): void {
    this.store.dispatch(new SavePharmacyForm(formValue))
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data) {
          this.signUpProgress = SignUpProgressEnum.SetPIN;
        }
      });
  }

  savePharmacyDetails(): void {
    // we're done with setup so send the welcome email
    const currentUser = this.store.selectSnapshot(AuthState.currentUser);

    this.store.dispatch(new SavePharmacyDetails())
      .pipe(take(1), withLatestFrom(this.success$))
      .subscribe(([_, success]) => {
        if (success) {
          this.store.dispatch(new SavePharmacyForm(null));
          this.store.dispatch(new SavePharmacyNPI(null));
          this.store.dispatch(new SavePharmacySelectedBaa(null));
        }

        this.showSignUpProgressDialog = false;
      });
  }

}
